import * as ko from "knockout";
import {MutableAbstract, template as tpl} from "./MutableAbstract";
import {IExportFlowMutable} from "../../index";
import {nsExportTemplate} from "../../fn";
import {IExportAttribute, IExportFlow, ISearchParams} from "../../../../index";
import {ObjectTypeId, SNACKBAR_DURATION_LONG} from "../../../../constants";
import {createErrorMessage} from "../../../../util/misc";
import {global, lm} from "../../../../appContext";
import {_} from 'lodash';
import {nsFa} from "../../../fa/fn";
import {IParams} from "./index";
import PromiseRequest from "../../../../req/PromiseRequest";
import {nsSyncFields} from "../../../../req/nsSyncFields";
import {IRequestObject} from "../../../../req/index";
import {IComboboxV2Options} from "../../../combobox/v2";
import {createServiceListPromise} from "../../../combobox/v2-sources";
import {nsTooltip} from "../../../../util/nsTooltip";
import i = nsFa.i;
import tpl_exportHtml from './tpl_export.html?raw';
import tpl_export_buttonsHtml from './tpl_export_buttons.html?raw';

export const template = tpl
    .replace('<!-- {{TEMPLATE_TABLE}} -->', tpl_exportHtml)
    .replace('<!-- {{TEMPLATE_BUTTONS}} -->', tpl_export_buttonsHtml)
;

export class viewModel extends MutableAbstract {
    protected readonly type = 'export';
    private readonly req_getsyncstepstandardmappings = new PromiseRequest('getsyncstepstandardmappings');
    private readonly standardMappings: KnockoutObservableArray<IExportFlow> = ko.observableArray<IExportFlow>([]);
    private readonly getSyncfieldsRequestParams = nsSyncFields.getSyncfieldsRequestParams
    private reqobj_getexportattributes!: IRequestObject<IExportAttribute[]>;

    constructor(params: IParams) {
        super(params);
        const onObjectTypeOrSyncstepChange = () => {
            if (!this.objecttype() || !this.syncstep()) {
                this.standardMappings([]);
                return;
            }
            this.initRequest();
        };
        this.kosub.subscribe(this.objecttype, onObjectTypeOrSyncstepChange);
        this.kosub.subscribe(this.syncstep, onObjectTypeOrSyncstepChange);
        this.initRequest();
    }

    protected initRequest() {
        const objecttype = this.objecttype();
        const syncstep = this.syncstep();
        if (!objecttype || !syncstep) {
            return Promise.resolve();
        }
        return this.req_getsyncstepstandardmappings
            .request({
                objecttypeid: objecttype.id,
                syncstepid: syncstep.syncstep.id,
            })
            .then((data: IExportFlow[]) => this.standardMappings(data))
            .catch((reason: string) => this.messageData(createErrorMessage(String(reason))))
            ;
    }

    protected data: KnockoutComputed<IExportFlowMutable[]> = ko.pureComputed((): IExportFlowMutable[] => {
        return this._data().filter((item: IExportFlowMutable) => nsExportTemplate.isExportFlowMutableOrdinaryExport(item));
    });

    protected createExportFlowMutable() {
        super._createExportFlowMutable(false);
    }

    private onAddDefaultMappingsClick() {
        const objecttype = this.objecttype();
        const syncstep = this.syncstep();
        if (objecttype && syncstep) {
            this.reqobj_getexportattributes?.promise.abort()
            this.reqobj_getexportattributes = nsExportTemplate.getExportAttributes(syncstep.syncstep.id, objecttype.id);
            this.reqobj_getexportattributes.request
                .then((data: IExportAttribute[]) => this.exportAttributes = data)
                .then(() => {
                    const mutableMappings = this.standardMappings().map((ef: IExportFlow) => nsExportTemplate.exportFlowToMutable(ef, this.exportAttributes));
                    mutableMappings.forEach(m => {
                        this._data.push(m)
                        this.mutable.trackFlowErrors(m)
                    });
                    global.snackbarData({
                        message: `subject is added|s:${mutableMappings.length} ((attribute|n:${mutableMappings.length}))`,
                        undo: () => mutableMappings.forEach(m => {
                            this._data.remove(m)
                            this.mutable.untrackFlowErrors(m)
                        })
                    });
                })
                .catch((reason: string) => global.snackbarData(_.extend(createErrorMessage(String(reason)), {duration: SNACKBAR_DURATION_LONG})));
        }
    }

    private onAddExchangeClick(version: string) {
        global.dialogManager.addComponent({
            content: {
                name: "component/export-template/mapping/mutable/dialog/exchange",
                params: {
                    exporttemplate: this.exporttemplate,
                    onSubmit: (flows: IExportFlowMutable[]) => {
                        global.snackbarData({
                            message: "subject is added|s:Exchange",
                            undo: () => flows.forEach(efm => {
                                this.mutable.untrackFlowErrors(efm)
                                this._data.remove(efm)
                            }),
                        });
                        this._data.push(...flows);
                        flows.forEach(f => this.mutable.trackFlowErrors(f))
                    },
                },
            },
            title: `${i('fa-envelope-plus')} Exchange`,
        })
    }

    private getFlow(targetattribute: string): IExportFlowMutable | undefined {
        return this._data().find(o => o.targetattribute()?.name == targetattribute);
    }

    private getExpressionValue(targetattribute: string): string {
        return this.getFlow(targetattribute)?.expression?.() ?? '';
    }

    protected override showButtons(type: "standard" | "exchange"): boolean {
        const objecttype = this.objecttype();
        switch (type) {
            case 'standard': {
                return !!this.standardMappings().length;
            }
            case "exchange": {
                const a = this.type == 'export';
                const b = objecttype?.id == ObjectTypeId.User;
                const c = this.syncstep()?.syncstep.name.indexOf('Export AD') == 0;
                return a && b && c;
            }
        }
    }

    private getComboboxParams_attr(obj: IExportFlowMutable): IComboboxV2Options<IExportAttribute> {
        const objecttype = this.objecttype();
        const syncstep = this.syncstep();
        const listSource = createServiceListPromise<IExportAttribute>({
            name: 'getexportattributes',
            params: {
                syncstepid: syncstep?.syncstep.id ?? 0,
                objecttypeid: objecttype?.id ?? 0
            } as unknown as ISearchParams,
        })
        return {
            prepareData: {
                filter: o => this.isExportAttributeOrdinaryType(o),
            },
            inputAttrs: {placeholder: lm.t('choose|td')},
            option: {
                label: o => o.name,
                tooltip: o => o ? lm.t(nsTooltip.getTitle_exportAttribute(o) ?? '') : '',
            },
            promise: listSource.promise,
            onDispose: listSource.onDispose,
            selected: obj.targetattribute,
            initialMatch: o => o.name == obj.$original.targetattribute,
            inputStatus: (selected) => selected ? 'ok' : 'warning',
            // Many mapping rows mount at once on edit; defer option DOM until first open.
            lazyMountList: true,
            virtualize: true,
        }
    }

    override dispose() {
        super.dispose();
        this.req_getsyncstepstandardmappings.abort();
        this.reqobj_getexportattributes?.promise.abort()
    }

}